import React from 'react';
import Banner from '../../../components/Banner/index';
import Footer from '../../../components/Footer/index';
import ToolkitElement from '../../../components/ToolkitElement/index';

class ToolkitPage extends React.Component {
  render() {
    return (
      <div>
        <Banner />
        <div className="sub-banner">
          <div className="overlay">
            <div className="container">
              <div className="breadcrumb-area">
                <div className="top">
                  <h1>Toolkit</h1>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="typography-page">
          <div className="container">
            <div className="row mrg-btm-40">
              <div className="col-lg-12 mrg-btm-30">
                <h4 className="headline normal-text">Toolkit</h4>
                <p>En esta sección encontrarás material guía para ayudarte a
                  entender mejor el proceso de circulación de producciones.
                  Tanto arriendo, ventas como co-producciones.
                  El material que aquí encontrarás contiene definiciones básicas,
                  contratos tipos y guías.
                </p>

                <p>
                  In this section you will find guide material to help you better
                  understand the process of circulation of productions. Both rent,
                  sales and co-productions.
                  The material that you will find here contains basic definitions,
                  types contracts and guides.
                </p>
              </div>

              <div className="col-lg-12">
                <h4 className="headline normal-text">
                  Guía de politicas de exportación de bienes culturales en teatros de latinoamérica
                </h4>
                <ToolkitElement pdf="/pdf/guia-politicas-exportacion.pdf" />
              </div>

              <div className="col-lg-12">
                <h4 className="headline normal-text">
                  Modelo de contrato de alquiler
                </h4>
                <ToolkitElement pdf="/pdf/contrato-alquiler.pdf" />
              </div>

              <div className="col-lg-12">
                <h4 className="headline normal-text">
                  Contrato tipo coproducción
                </h4>
                <ToolkitElement pdf="/pdf/contrato-tipo-coproduccion.pdf" />
              </div>

            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ToolkitPage;



// WEBPACK FOOTER //
// ./src/containers/General/ToolkitPage/index.js